import clsx from "clsx";
import AgentWorkerAvatar from "@/components/worker/AgentWorkerAvatar";

export type AgentAvatarProps = {
  agentName: string;
  size?: number;
  className?: string;
};

/** Agent identity in agentic surfaces — Ani always uses the product logo. */
export function AgentAvatar({ agentName, size = 18, className }: AgentAvatarProps) {
  if (agentName.toLowerCase() === "ani") {
    return (
      <img
        src="/images/logo.svg"
        alt="Ani"
        width={size}
        height={size}
        className={clsx("shrink-0 rounded-full object-contain", className)}
      />
    );
  }

  return (
    <AgentWorkerAvatar
      name={agentName}
      size={size}
      className={clsx("shrink-0", className)}
    />
  );
}
